<template>
  <section class="ui-table-panel">
    <div v-if="notice || $slots.filters || $scopedSlots.filters" class="ui-table-panel__header">
      <UiFormNotice v-if="notice" class="ui-table-panel__notice">{{ $t(notice) }}</UiFormNotice>
      <div v-if="$slots.filters || $scopedSlots.filters" class="ui-table-panel__filters">
        <slot name="filters" />
      </div>
    </div>
    <div v-if="$slots.content || $scopedSlots.content" class="ui-table-panel__content">
      <slot name="content" />
    </div>
    <slot />
    <footer v-if="showPagination && ($slots.pagination || $scopedSlots.pagination)" class="ui-table-panel__footer">
      <slot name="pagination" />
    </footer>
  </section>
</template>

<script>
import UiFormNotice from './UiFormNotice'

export default {
  name: 'UiTablePanel',
  components: { UiFormNotice },
  props: {
    notice: { type: String, default: '' },
    showPagination: { type: Boolean, default: true }
  }
}
</script>

<style lang="scss" scoped>
/* 控件区、数据区及可选分页区共用同一外框与圆角。 */
.ui-table-panel {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  box-sizing: border-box;
  border: 1px solid var(--ui-border-color-subtle);
  border-radius: var(--ui-radius-medium);
  background: var(--ui-bg-panel);
}

.ui-table-panel__header {
  min-width: 0;
  padding: var(--ui-space-lg);
  border-bottom: 1px solid var(--ui-border-color-subtle);
}

.ui-table-panel__notice:last-child {
  margin-bottom: 0;
}

.ui-table-panel__filters {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--ui-space-sm);
  min-width: 0;
}

/* flex gap 已负责控件间距，清除 Element 连续按钮自带的额外左边距。 */
.ui-table-panel__filters ::v-deep .el-button + .el-button {
  margin-left: 0;
}

.ui-table-panel__content {
  min-width: 0;
  padding: var(--ui-space-lg);
  border-bottom: 1px solid var(--ui-border-color-subtle);
}

.ui-table-panel__content > :first-child {
  margin-top: 0;
}

.ui-table-panel__content > :last-child {
  margin-bottom: 0;
}

.ui-table-panel__footer {
  min-width: 0;
  overflow-x: auto;
  padding: var(--ui-space-xs) var(--ui-space-lg);
  border-top: 1px solid var(--ui-border-color-subtle);
  background: var(--ui-bg-panel-elevated);
}

.ui-table-panel__footer ::v-deep .ui-pagination {
  width: max-content;
  min-width: 100%;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

@media (max-width: 768px) {
  .ui-table-panel__header,
  .ui-table-panel__content {
    padding: var(--ui-space-md);
  }

  .ui-table-panel__footer {
    padding-right: var(--ui-space-md);
    padding-left: var(--ui-space-md);
  }
}

/* 只接管直属数据表的外沿；内部宽高、固定列、滚动和 ref 均由原 UiTable 维护。 */
.ui-table-panel > ::v-deep .ui-table.el-table {
  border: 0;
  border-radius: 0;
}

.ui-table-panel > ::v-deep .ui-table.el-table::before {
  display: none;
}
</style>
